import { render, staticRenderFns } from "./WebRtcStatisticsView.vue?vue&type=template&id=e7d3d742&scoped=true"
import script from "./WebRtcStatisticsView.vue?vue&type=script&lang=js"
export * from "./WebRtcStatisticsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d3d742",
  null
  
)

export default component.exports